import React from 'react';
import RoomList from './completedPresentation/roomList/RoomList';
import MainInfoSection from './completedPresentation/MainInfoSection';
import PublicPortraitSection from './completedPresentation/PublicPortraitSection';
import ImagesSection from './completedPresentation/ImagesSection';
import PropertyTaxesList from './completedPresentation/taxesList/PropertyTaxesList';
import PropertySupplementsList from './completedPresentation/supplementList/PropertySupplementList';
import PropertyStopSalesList from './completedPresentation/stopSales/PropertyStopSalesList';
import { useAppConfigurationSections } from '../../../../contexts/AppConfigurationContext';
import { AppSectionsCore } from '../../../../types/appConfiguration/appConfigTypes';
import ReadOnlyUserAlert from '../../ReadOnlyUserAlert';

const CompletedPropertyPresentation = () => {
    const { core } = useAppConfigurationSections();

    return (
        <div className='completed-presentation__page'>
            <ImagesSection />
            <ReadOnlyUserAlert text='read_only_hotels' />
            <MainInfoSection />
            <PublicPortraitSection />
            <RoomList />
            {core.pages[AppSectionsCore.TAXES] ? <PropertyTaxesList /> : null}
            {core.pages[AppSectionsCore.SUPPLEMENTS] ? (
                <PropertySupplementsList />
            ) : null}
            {core.pages[AppSectionsCore.STOP_SALES] ? (
                <PropertyStopSalesList />
            ) : null}
        </div>
    );
};

export default CompletedPropertyPresentation;
